import { required, minLength, email, ValidationRule, sameAs } from 'vuelidate/lib/validators';

export interface SignupConfig {
  data: {
    email: string | null;
    password: string | null;
    repeatPassword: string | null;
    displayName: string | null;
    firstName: string | null;
    lastName: string | null;
  };
  html: {
    default: {
      header: {
        title: string;
        text: null;
      };
      button: {
        text: string;
        icon: null;
      };
    };
    input: {
      model: string;
      type: string;
      placeholder: string;
      autocomplete?: string;
    }[];
  };
  validations: {
    email: {
      required: () => ValidationRule;
      email: () => ValidationRule;
    };
    password: {
      required: () => ValidationRule;
      minLength: ValidationRule;
    };
    repeatPassword: {
      required: () => ValidationRule;
      minLength: ValidationRule;
    };
    firstName: {
      minLength: ValidationRule;
    };
    phone: {
      minLength: ValidationRule;
    };
    agreeTerms: {
      required: () => ValidationRule;
      checked: (value: boolean) => boolean;
    };
    newsletterTerms: {
      checked: (value: boolean) => boolean;
    };
  };
}

export default {
  data: {
    email: null,
    password: null,
    repeatPassword: null,
    firstName: null,
    phone: null,
    agreeTerms: false,
    newsletterTerms: false,
  },
  html: {
    default: {
      header: {
        title: 'Sukurk Delfi paskyrą',
        text: null,
      },
      button: {
        text: 'Registruotis',
        icon: null,
      },
    },
    input: [
      {
        model: 'email',
        type: 'email',
        placeholder: 'El. paštas',
        autocomplete: 'email',
      },
      {
        model: 'password',
        type: 'password',
        placeholder: 'Slaptažodis*',
      },
      {
        model: 'repeatPassword',
        type: 'password',
        placeholder: 'Pakartoti slaptažodį*',
      },
      {
        model: 'firstName',
        type: 'text',
        placeholder: 'Vardas',
        autocomplete: 'given-name',
      },
      {
        model: 'phone',
        type: 'text',
        placeholder: 'Telefono numeris',
        autocomplete: 'tel',
      },
      {
        model: 'agreeTerms',
        type: 'checkbox',
        placeholder: ' Sutinku su privatumo politika ir naudojimosi taisyklėmis',
      },
      {
        model: 'newsletterTerms',
        type: 'checkbox',
        placeholder: ' Sutinku gauti rinkodaros pasiūlymus apie Delfi ir jų partnerių paslaugas, akcijas ir žaidimus',
      },
    ],
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(8),
    },
    repeatPassword: {
      required,
      minLength: minLength(8),
      sameAsPassword: sameAs('password'),
    },
    firstName: {
      minLength: minLength(3),
    },
    phone: {
      minLength: minLength(12),
    },
    agreeTerms: {
      required,
      checked: (value: boolean) => value === true,
    },
    newsletterTerms: {
      checked: (value: boolean) => undefined !== value && value !== null,
    },
  },
};
